"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MessageInformation = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _react = _interopRequireDefault(require("react"));
var _kDsFoundation = _interopRequireDefault(require("../../lib/k-ds-foundation"));
var _excluded = ["message"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
var IconInformation = function IconInformation(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M9 16.5a7.5 7.5 0 1 1 0-15 7.5 7.5 0 0 1 0 15ZM9 15A6 6 0 1 0 9 3a6 6 0 0 0 0 12Zm-.75-9.75h1.5v1.5h-1.5v-1.5Zm0 3h1.5v4.5h-1.5v-4.5Z",
    fill: "#09121F"
  }));
};
IconInformation.defaultProps = {
  width: "18",
  height: "18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var StyledMessageInformation = /*#__PURE__*/_styledComponents["default"].div.withConfig({
  componentId: "kds-v1__sc-1a2c6q5-0"
})(["display:flex;align-items:flex-start;border-radius:4px;box-sizing:border-box;padding:16px 20px;", " .icon{min-width:18px;}.message{overflow:hidden;", ";overflow-wrap:break-word;}"], _kDsFoundation["default"].setColorWithFallback('background: ', 'blue-100'), _kDsFoundation["default"].setSpacingWithFallback('margin-left: ', 'spacing-04'));
var MessageInformation = exports.MessageInformation = function MessageInformation(_ref) {
  var message = _ref.message,
    moreProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(StyledMessageInformation, moreProps, /*#__PURE__*/_react["default"].createElement(IconInformation, {
    className: "icon"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "message k-ds-label-01"
  }, message));
};